import { useState, useCallback } from 'react';

export const usePrefabs = (initialPrefabs = []) => {
  const [prefabs, setPrefabs] = useState(initialPrefabs);
  const [selectedPrefabId, setSelectedPrefabId] = useState(null);
  const [prefabSearchTerm, setPrefabSearchTerm] = useState('');
  const [editingPrefabId, setEditingPrefabId] = useState(null);
  const [editingName, setEditingName] = useState('');

  const addPrefab = useCallback((prefab) => {
    setPrefabs(prev => [...prev, prefab]);
  }, []);

  const updatePrefab = useCallback((prefabId, updates) => {
    setPrefabs(prev => prev.map(p => p.id === prefabId ? { ...p, ...updates } : p));
  }, []);

  const deletePrefab = useCallback((prefabId) => {
    setPrefabs(prev => prev.filter(p => p.id !== prefabId));
    if (selectedPrefabId === prefabId) {
      setSelectedPrefabId(null);
    }
  }, [selectedPrefabId]);

  const getPrefab = useCallback((prefabId) => {
    return prefabs.find(p => p.id === prefabId);
  }, [prefabs]);

  const getFilteredPrefabs = useCallback((excludeId = null) => {
    return prefabs
      .filter(p => p.id !== excludeId)
      .filter(p => p.name.toLowerCase().includes(prefabSearchTerm.toLowerCase()));
  }, [prefabs, prefabSearchTerm]);

  return {
    prefabs,
    setPrefabs,
    selectedPrefabId,
    setSelectedPrefabId,
    prefabSearchTerm,
    setPrefabSearchTerm,
    editingPrefabId,
    setEditingPrefabId,
    editingName,
    setEditingName,
    addPrefab,
    updatePrefab,
    deletePrefab,
    getPrefab,
    getFilteredPrefabs
  };
};
